import { createClient } from 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js/+esm';

const supabase = createClient(
  'https://nzypaksmxerwfwvigvou.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56eXBha3NteGVyd2Z3dmlndm91Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1OTAzMDcsImV4cCI6MjA2MjE2NjMwN30.wu3oaSt2F1VdqLK6kpYXTv-9Zr-jXlya2TLfOvIGt3E'
);

export async function showQuotePopup(rfq) {
  const modal = document.createElement('div');
  modal.style.cssText = `
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,0.5); display: flex; align-items: center;
    justify-content: center; z-index: 10000;
  `;

  const settlement = rfq.settlement_date;

  let displayName = rfq.is_anonymous ? 'аноним' : (rfq.owner_email || 'Пользователь');
  const visibility = rfq.recipient_id ? 'single' : 'multi';

  modal.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; width: 400px; font-family: sans-serif; line-height: 1.8">
      <h3>Запрос от ${displayName} (${visibility})</h3>
      <p><strong>Дата расчётов:</strong> ${settlement}</p>
      <p><strong>Метод:</strong> ${rfq.settlement_type}</p>

      ${rfq.rfq_request_items.map((item, i) => {
        const isin = item?.securities?.isin || '–';
        const name = item?.securities?.name || '–';
        return `
          <div style="margin-bottom: 1rem">
            <strong>${name} (${isin})</strong><br/>
            <label>Объём: ${item.amount}</label><br/>
            <label>Цена: <input type="number" id="price-${isin}" step="0.01" style="width: 100%;" /></label><br/>
            <label>НКД: <span id="nkd-${isin}">–</span></label><br/>
            <label>Стоимость: <span id="cost-${isin}">–</span></label><br/>
            <label>Полная стоимость: <span id="total-${isin}">–</span></label>
          </div>`;
      }).join('')}

      <label><strong>Срок действия (мин):</strong><br/>
        <input type="number" id="quote-expiry" value="2" style="width: 100%" />
      </label><br/><br/>

      <div style="text-align: right;">
        <button id="submit-quote">Отправить</button>
        <button onclick="document.body.removeChild(this.closest('#quote-popup'))" style="margin-left: 10px;">Отмена</button>
      </div>
    </div>
  `;

  modal.id = 'quote-popup';
  document.body.appendChild(modal);

  rfq.rfq_request_items.forEach(async item => {
    const d = settlement;
    const isin = item?.securities?.isin;
    const amount = item.amount;
    if (!isin) return;

    const priceInput = document.getElementById(`price-${isin}`);
    priceInput.addEventListener('input', () => updateCostAndTotal(isin, amount));

    try {
      const response = await fetch('/data/bond_data.json');
      const json = await response.json();
      const bond = json[isin];
      if (!bond) return;
      const coupon = bond.coupons.find(c => new Date(c.start_date) <= new Date(d) && new Date(d) < new Date(c.end_date));
      if (!coupon) return;
      const daysPassed = (new Date(d) - new Date(coupon.start_date)) / (1000 * 60 * 60 * 24);
      const nkd = coupon.value * daysPassed / coupon.days * amount;
      const el = document.getElementById(`nkd-${isin}`);
      if (el) el.textContent = nkd.toFixed(2);
      el.dataset.nkd = nkd;
    } catch (e) {
      console.error('Ошибка при загрузке НКД:', e);
    }
  });

  function updateCostAndTotal(isin, amount) {
    const price = parseFloat(document.getElementById(`price-${isin}`).value);
    const nkd = parseFloat(document.getElementById(`nkd-${isin}`)?.dataset?.nkd || '0');
    const cost = isNaN(price) ? 0 : price * amount * 10;
    const total = cost + (isNaN(nkd) ? 0 : nkd);

    document.getElementById(`cost-${isin}`).textContent = cost.toFixed(2);
    document.getElementById(`total-${isin}`).textContent = total.toFixed(2);
  }

  document.getElementById('submit-quote').onclick = async () => {
    const { data, error } = await supabase.auth.getUser();
    const user = data?.user;
    if (!user) return alert('Не авторизован');

    const expiresIn = parseInt(document.getElementById('quote-expiry').value);
    const expiresAt = new Date(Date.now() + expiresIn * 60 * 1000).toISOString();

    const { data: quote, error: quoteErr } = await supabase.from('rfq_quotes').insert({
      dealer_id: user.id,
      rfq_id: rfq.id,
      status: 'quoted',
      expires_at: expiresAt
    }).select().single();

    if (quoteErr || !quote) return alert('Ошибка: ' + (quoteErr?.message || ''));

    const quoteItems = rfq.rfq_request_items.map(item => {
      const isin = item?.securities?.isin;
      const price = parseFloat(document.getElementById(`price-${isin}`).value);
      return {
        quote_id: quote.id,
        security_id: item.securities.id,
        price
      };
    }).filter(x => !isNaN(x.price));

    const res = await supabase.from('rfq_quote_items').insert(quoteItems);
    if (res.error) return alert('Ошибка при сохранении цен: ' + res.error.message);

    alert('Котировка отправлена!');
    modal.remove();
  };
}